import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac3b9350"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { class: "f" }

import Top from "../top/Index.vue";
import Aside from "../aside/Index.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useStore();

const changeIsCollapse = () => {
  store.dispatch("change", !store.state.isCollapse);
};

let router = useRouter();

const routes = JSON.parse(localStorage.getItem("routes")!);
let title = ref();

watch(
  () => router.currentRoute.value,
  (newValue, oldValue) => {
    title.value = newValue.meta.title;
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_Fold = _resolveComponent("Fold")!
  const _component_Expand = _resolveComponent("Expand")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { class: "header-bg" }, {
          default: _withCtx(() => [
            _createVNode(Top)
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, { class: "el-con" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_aside, {
              width: "auto",
              class: "el-aside"
            }, {
              default: _withCtx(() => [
                _createVNode(Aside)
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, { class: "el-main" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_icon, {
                    size: 20,
                    color: "#30318F",
                    class: "c-p m-r10",
                    onClick: changeIsCollapse
                  }, {
                    default: _withCtx(() => [
                      (!_unref(store).state.isCollapse)
                        ? (_openBlock(), _createBlock(_component_Fold, { key: 0 }))
                        : (_openBlock(), _createBlock(_component_Expand, { key: 1 }))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", null, _toDisplayString(_unref(title)), 1)
                ]),
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})